import React, { useEffect } from "react";
import {
  Route,
  Routes,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
//pages
import Survey from "./pages/survey";
import Home from "./pages/Home";
import Login from "./pages/login";
import Register from "./pages/register";
import SurveyBuilder from "./pages/SurveyBuilder";
import SurveyViewer from "./pages/viewSurveys";
import Header from "./components/header";
import Footer from "./components/footer";
import SurveyDashboard from "./pages/surveyDashboard";
import { useDispatch, useSelector } from "react-redux";

import { checkAuth } from "./redux/authSlice";
import PrivateRoute from "./components/privateRoute";
import NotFound from "./pages/notFound";

function AuthRedirector() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { user, checked } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(checkAuth()).unwrap().catch(() => {
      // optional: handle auth check failure here
    });
  }, [dispatch]);

  useEffect(() => {
    if (!checked || !user) return;

    const currentPath = location.pathname;
    const isAuthPage = ["/", "/login", "/register"].includes(currentPath);

    if (isAuthPage) {
        navigate(`/dashboard/${user.publicId}`);
    }
  }, [checked, user, navigate, location]);
  return null;
}

function App() {
  return (
    <>
    <AuthRedirector />
      <Header />
      <main className="min-h-screen pt-16">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route 
            path="/dashboard/:publicId" 
            element={
              <PrivateRoute>
                <SurveyDashboard />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/survey-builder/:publicId"             
            element={
              <PrivateRoute>
                <SurveyBuilder />
              </PrivateRoute>
            }  />
          <Route 
            path="/bsas/:publicId" 
            element={
                <Survey />
            } 
          />
          <Route path="/bsas" element={<SurveyViewer />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;
